<template>
    <div style="width:100%" ref="parent">
        <!-- <img id="video" ref="body" :src="image" style="width:100%" /> -->
        <canvas ref="video" style="width:100%" width="640" height="360" />
    </div>
</template>

<script>
    import parser from "@/components/tools/jpg.js"

    export default {
        props: {
            url: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                ws: null,
                connected: false,
                viewer: null,
                reConnectTimer: null
            }
        },
        mounted: function () {
            const self = this
            this.viewer = {
                canvas: null,
                context: null,
            }
            this.viewer.canvas = this.$refs.video
            this.viewer.context = this.viewer.canvas.getContext("2d")
            
            // var img = new Image()
            // img.onload = function () {
            //     self.viewer.canvas.width = img.naturalWidth
            //     self.viewer.canvas.height = img.naturalHeight
            //     self.viewer.context.drawImage(img, 0, 0)
            //     img.src = ""
            // }
            const socketCreator = function () {
                self.ws = new WebSocket(self.url)
                self.connected = true
                self.ws.onmessage = function (e) {
                    // img.src = "data:image/jpeg;base64,"+e.data

                    var binary = window.atob(e.data);
                    var length = binary.length;
                    var bytes = new Uint8Array(length);
                    for (var i = 0; i < length; i++) {
                        bytes[i] = binary.charCodeAt(i)
                    }

                    var image = new parser.JpegImage()

                    image.parse(bytes)
                    self.viewer.canvas.width = image.width
                    self.viewer.canvas.height = image.height
                    var baseImage = self.viewer.context.getImageData(0, 0, image.width, image.height)
                    image.copyToImageData(baseImage)
                    self.viewer.context.putImageData(baseImage, 0, 0)
                }
                self.ws.onclose = function (e) {
                    if (self.connected) {
                        console.log("connection disconnect! reconnect waiting", e.reason)
                        self.reConnectTimer = setTimeout(function(){
                            socketCreator()
                        }, 5000)
                    }
                }
            }
            socketCreator()
        },
        beforeDestroy: function () {
            console.log("beforeDestroy")
            if (this.reConnectTimer != null) {
                clearTimeout(this.reConnectTimer)
            }
            this.connected = false
            this.ws.close()
        },
        methods: {
        }
    }
</script>
